export default __webpack_public_path__ + "static/media/wayaquick.f5a48bf8.png";